import { httpsCallable as _httpsCallable } from 'firebase/functions'

import { functions } from './firebase'

export const httpsCallable = (...args) => _httpsCallable(functions, ...args)
